import React from 'react';

// IB-677 rework — compact horizontal (stacked) bars, matching the Procurement
// coverage-bar idiom: a grey track with proportional flex-div segments, no in-bar
// labels. Bar length encodes the row total relative to the largest row (magnitude);
// segments within a bar are proportional to their share of that row's total. This
// one component backs Gross→residual (two full-width composition rows, since both
// count the same risks), Risks-by-type, and the single-segment age/severity/
// verification profiles. Replaces the old Apex column charts.
// rows: [{ label, segments: [{ value, colourClass }] }]
export default function HBars({ rows = [], note, labelWidth = 110, emptyLabel }) {
    const rowTotal = (row) => (row.segments || []).reduce((carry, segment) => carry + (Number(segment.value) || 0), 0);

    if (!rows.length || rows.every((row) => rowTotal(row) === 0)) {
        return <div className="tw-text-sm tw-text-charcoal-50">{emptyLabel || $t('No data')}</div>;
    }

    const max = Math.max(1, ...rows.map(rowTotal));

    return (
        <div>
            <div className="tw-flex tw-flex-col tw-gap-2.5">
                {rows.map((row, index) => {
                    const total = rowTotal(row);
                    const outerWidth = (total / max) * 100;

                    return (
                        <div key={index} className="tw-grid tw-items-center tw-gap-2 tw-text-2xs" style={{ gridTemplateColumns: `${labelWidth}px 1fr` }}>
                            <div className="tw-font-medium tw-text-charcoal-75 tw-truncate">{row.label}</div>
                            <div className="tw-h-4 tw-rounded tw-bg-grey tw-overflow-hidden">
                                <div className="tw-flex tw-h-full" style={{ width: `${outerWidth}%` }}>
                                    {(row.segments || []).map((segment, segIndex) => (
                                        <div
                                            key={segIndex}
                                            className={segment.colourClass}
                                            style={{ width: `${total > 0 ? ((Number(segment.value) || 0) / total) * 100 : 0}%` }}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {note && <div className="tw-mt-2 tw-text-2xs tw-text-charcoal-50 tw-leading-snug">{note}</div>}
        </div>
    );
}
